import { assetUrlBuilder } from "@max/common/assets";

export const assetUrl = assetUrlBuilder({
  base: process.env.REACT_APP_ASSETS_BASE_URL,
});
